import type { GridValues, GridValuesRow } from "@/types/grid";
import {
  bingoGrid,
  bingoRow,
  bingoCell,
  bingoCellEditable,
  bingoCellEmpty,
  bingoCellEditableEmpty,
  bingoCellError,
  bingoRowError,
} from "@/styles/bingo-grid";

export type CellErrors = boolean[][];

export function GridDisplay({
  numbers,
  onChange,
  cellErrors,
  rowErrors,
}: {
  numbers: GridValues;
  onChange: (numbers: GridValues) => void;
  cellErrors?: CellErrors;
  rowErrors?: boolean[];
}) {
  const handleCellChange = (rowIndex: number, cellIndex: number, value: string) => {
    const trimmed = value.trim();
    const newValue = trimmed === "" ? null : Number(trimmed);
    if (trimmed !== "" && Number.isNaN(newValue)) return;

    const newNumbers = numbers.map((row, ri) =>
      ri === rowIndex
        ? (row.map((cell, ci) => (ci === cellIndex ? newValue : cell)) as GridValuesRow)
        : row,
    ) as GridValues;

    onChange(newNumbers);
  };

  return (
    <div css={bingoGrid}>
      {numbers.map((row, rowIndex) => {
        const hasRowError = rowErrors?.[rowIndex] ?? false;
        return (
          <div key={rowIndex} css={[bingoRow, hasRowError && bingoRowError]}>
            {row.map((cell, cellIndex) => {
              const isEmpty = cell === null;
              const hasCellError = cellErrors?.[rowIndex]?.[cellIndex] ?? false;
              return (
                <input
                  key={cellIndex}
                  type="text"
                  inputMode="numeric"
                  css={[
                    bingoCell,
                    bingoCellEditable,
                    isEmpty && bingoCellEmpty,
                    isEmpty && bingoCellEditableEmpty,
                    hasCellError && bingoCellError,
                  ]}
                  value={cell ?? ""}
                  tabIndex={rowIndex * 9 + cellIndex + 1}
                  onChange={(e) => handleCellChange(rowIndex, cellIndex, e.target.value)}
                />
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
